@if (cb._feature.selectors.isDialogOpen.asSignal()) {
  <!--Element used as a origin to which clipboard-overlay is attached. Not
  visible in the UI, used just to position an overlay -->
  <div
    class="atn-clipboard-overlay-origin"
    [style.top.px]="cb._feature.selectors.dialogPositionY.asSignal()"
    [style.left.px]="cb._feature.selectors.dialogPositionX.asSignal()"
    #originEl
  ></div>

  <atn-ds-attached-overlay
    [origin]="originEl"
    [offsetX]="cb._feature.selectors.dialogOffsetX.asSignal()"
    [offsetY]="cb._feature.selectors.dialogOffsetY.asSignal()"
    (backdropClick)="closeClipboardOverlayHandler('Backdrop')"
  >
    <atn-ds-widget title="Clipboard">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="closeClipboardOverlayHandler('Header.Buttons.Close')"
        ></i>
      </div>
      <div class="atn-clipboard-overlay">
        <div class="atn-clipboard-overlay__selection">
          <atn-ds-checkbox
            [selected]="cb._feature.selectors.isAllSelected.asSignal()"
            [someSelected]="cb._feature.selectors.isSomeSelected.asSignal()"
            (selectedChange)="handleAllItemsSelectionChange()"
          />
          <span>
            {{ cb._feature.selectors.selectedCount.asSignal() }}
            Selected
          </span>
          <!-- Display actions if we have some selected -->
          @if (cb._feature.selectors.isSomeSelected.asSignal()) {
            <!-- Display past icon in case we are in paste mode. -->
            @if (cb._feature.selectors.isPasteMode.asSignal()) {
              <i
                class="atn-icon atn-paste atn-blue"
                (click)="pasteSelectedItems()"
              ></i>
            }
            <i
              class="atn-icon atn-trash atn-red"
              (click)="deleteSelectedItems()"
            ></i>
          }
        </div>
        @for (
          identifiedItem of cb._feature.selectors.items.asSignal();
          track $index
        ) {
          <div class="atn-clipboard-overlay__item">
            <atn-ds-checkbox
              [selected]="
                cb._feature.selectors.isSelected(identifiedItem).asSignal()
              "
              (selectedChange)="
                handleItemSelectionChange(identifiedItem, $event)
              "
            />
            <span>
              {{ identifiedItem.item.getName() }}
            </span>
          </div>
        }
      </div>
    </atn-ds-widget>
  </atn-ds-attached-overlay>
}
